// extracted by mini-css-extract-plugin
module.exports = {"content":"_3H_LV","offerInAccount":"_3ZzUQ","title2":"_3oUqw","cguApple":"_37WTK","restoreButtonContainer":"_36u7X","restoreButton":"_3N04P"};